import { render, staticRenderFns } from "./PoliticsCard.vue?vue&type=template&id=3a242b62&"
import script from "./PoliticsCard.vue?vue&type=script&lang=js&"
export * from "./PoliticsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports